import { Routes } from '@angular/router';

import { LayoutPrincipalComponent } from '@shared/components/layout-principal/layout-principal.component';

import { AdminControleAcessosComponent } from './controle-acesso/admin-controle-acesso.component';

export const ADMIN_CONTROLE_ACESSO_ROUTES: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        component: AdminControleAcessosComponent,
      },

      {
        path: 'perfis',
        loadChildren: () =>
          import('../perfil/perfil.router').then((m) => m.ADMIN_PERFIS_ROUTES),
      },
      {
        path: 'usuarios',
        loadChildren: () =>
          import('../usuario/usuario.router').then(
            (m) => m.ADMIN_USUARIOS_ROUTES
          ),
      },
    ],
  },
];
